/* De aanvulstrook in de winkelmandlade. Zie snippets/kopero-mandje.liquid voor
   waarom hij er zo uitziet; hier staat alleen wat de browser doet.

   Alle kaarten staan al in de pagina, door Liquid gerenderd en vertaald, en
   beginnen verborgen. Dit bestand beslist welke er te zien zijn. Dat kan niet
   in Liquid, want de keuze hangt af van het antwoord op de vraag en dat staat
   in localStorage, niet op de server.

   Waarom losse gebeurtenissen op document en niet op de strook zelf: Horizon
   vervangt bij elke wijziging de inhoud van #CartDrawer of .drawer__inner door
   vers gerenderde HTML. Een luisteraar op een element in de lade is dan meteen
   weg, en een script dat via innerHTML binnenkomt draait niet opnieuw. Dus:
   een keer luisteren op document, en na elke hertekening opnieuw toepassen via
   de observer onderaan. */
(function () {
  'use strict';

  var SLEUTEL = 'kopero-koperwater';

  function antwoord() {
    try {
      return window.localStorage.getItem(SLEUTEL);
    } catch (e) {
      return null;
    }
  }

  function onthoud(waarde) {
    try {
      window.localStorage.setItem(SLEUTEL, waarde);
    } catch (e) {}
  }

  /* Kaarten met 'altijd' passen bij elk antwoord. De andere horen bij precies
     een antwoord en blijven anders weg: een kan aanbieden aan iemand die zegt
     dat hij onderweg drinkt is geen aanvulling maar ruis. Wie bij het antwoord
     hoort gaat voor, daarna telt de rang. */
  function kies(kaarten, a, max) {
    var geschikt = kaarten.filter(function (k) {
      var voor = k.getAttribute('data-knd-voor');
      return voor === 'altijd' || voor === a;
    });

    geschikt.sort(function (x, y) {
      var xr = x.getAttribute('data-knd-voor') === a ? 0 : 1;
      var yr = y.getAttribute('data-knd-voor') === a ? 0 : 1;
      if (xr !== yr) return xr - yr;
      return Number(x.getAttribute('data-knd-rang')) - Number(y.getAttribute('data-knd-rang'));
    });

    return geschikt.slice(0, max);
  }

  function pasToe() {
    var wortel = document.querySelector('[data-knd]');
    if (!wortel) return;

    var vraag = wortel.querySelector('[data-knd-vraag]');
    var kop = wortel.querySelector('[data-knd-kop]');
    var kaarten = Array.prototype.slice.call(wortel.querySelectorAll('[data-knd-kaart]'));

    var a = antwoord();
    var vraagStaatOpen = !a;
    if (vraag) vraag.hidden = !vraagStaatOpen;

    /* Staat de vraag nog open, dan hoogstens een kaart: de vraag zelf is het
       belangrijkste en moet niet ondersneeuwen. */
    var zichtbaar = kies(kaarten, a, vraagStaatOpen ? 1 : 2);

    kaarten.forEach(function (k) {
      k.hidden = zichtbaar.indexOf(k) === -1;
    });

    if (kop) kop.hidden = zichtbaar.length === 0;
    wortel.hidden = kaarten.length === 0 || (!vraagStaatOpen && zichtbaar.length === 0);
    var wrapper = wortel.closest('[data-knd-wrapper]');
    if (wrapper) wrapper.hidden = wortel.hidden;
  }

  var bezig = false;

  function toevoegen(knop, id) {
    if (bezig) return;
    bezig = true;
    knop.disabled = true;

    /* sections meevragen en het antwoord aan cart-drawer geven is de manier
       van Horizon om de lade bij te werken: nieuwe regel, nieuw subtotaal en
       een nieuwe strook, zonder herladen. */
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: id, quantity: 1, properties: { _bron: 'sidecart' } }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.ok ? r.json() : Promise.reject(r);
      })
      .then(function (staat) {
        var lade = document.querySelector('cart-drawer');
        if (lade && typeof lade.renderContents === 'function') {
          lade.renderContents(staat);
        }
        bezig = false;
      })
      .catch(function () {
        bezig = false;
        knop.disabled = false;
      });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var keuze = e.target.closest('[data-knd-antwoord]');
    if (keuze) {
      onthoud(keuze.getAttribute('data-knd-antwoord'));
      pasToe();
      return;
    }

    var knop = e.target.closest('[data-knd-toevoegen]');
    if (knop) {
      toevoegen(knop, parseInt(knop.getAttribute('data-knd-toevoegen'), 10));
    }
  });

  /* Alleen childList en subtree: het omzetten van hidden is een
     attribuutwijziging en wordt hier dus niet gemeld. Anders zou pasToe
     zichzelf aan de gang houden. */
  var wacht;
  function plan() {
    clearTimeout(wacht);
    wacht = setTimeout(pasToe, 60);
  }

  var lade = document.querySelector('cart-drawer');
  if (lade && 'MutationObserver' in window) {
    new MutationObserver(plan).observe(lade, { childList: true, subtree: true });
  }

  pasToe();
})();
